import axios from 'axios';
import { authService } from './auth-service';

export function sendbirdSendBriefAll(data) {
  const endpoint = process.env.REACT_APP_SENDBIRD_SEND_ALL;
  const headers = {
    Authorization: `Bearer ${authService.getToken()}`,
    'Content-type': 'application/json',
  };

  const axiosService = axios.create({
    baseURL: endpoint,
    timeout: 10000,
    headers,
  });

  const payload = {
    data: {
      campaignId: data.campaignId,
      userId: data.userId,
      permissionId: data.permissionId,
      message: data.message,
      documentData: {
        name: data.documentData.name,
        filePath: data.documentData.filePath,
        fileType: data.documentData.fileType,
        size: data.documentData.size,
      },
    },
  };

  return axiosService.post('/brief', payload)
    .then(response => {
      return response;
    });
}

export function sendbirdSendDeliverableAll(data) {
  const endpoint = process.env.REACT_APP_SENDBIRD_SEND_ALL;
  const headers = {
    Authorization: `Bearer ${authService.getToken()}`,
    'Content-type': 'application/json',
  };

  const axiosService = axios.create({
    baseURL: endpoint,
    timeout: 10000,
    headers,
  });

  const payload = {
    data: {
      campaignId: data.campaignId,
      userId: data.userId,
      permissionId: data.permissionId,
      message: data.message,
      deliverableData: {
        title: data.deliverableData.title,
        assetType: data.deliverableData.assetType,
        channelType: data.deliverableData.channelType,
        dueDate: data.deliverableData.dueDate,
        liveDateEnd: data.deliverableData.liveDateEnd,
        description: data.deliverableData.description,
      },
    },
  };

  return axiosService.post('/deliverable', payload)
    .then(response => {
      return response;
    });
}



/** WEBPACK FOOTER **
 ** ./src/utils/sendbird-send-all-service.js
 **/